import React from "react";
import NikkiWrapper from "../wrapper/NikkiWrapper";
import "../../../styles/components/selectbook/SelectSteps.scss";
import useAppTranslation from "../../../hooks/useAppTranslation";

export default function SelectType({
  onNext,
  onPrev,
  setType,
  type,
  onAlert,
  onSelectSound,
  onNextSound,
  onPrevSound,
}) {
  const { t } = useAppTranslation("components/selectbook/selectType");
  const genreList = [
    {
      value: "그림 동화",
      labelKey: "types.pictureBook",
      img: "/images/makingBranch/picture-book.webp",
    },
    {
      value: "그림 소설",
      labelKey: "types.graphicNovel",
      img: "/images/makingBranch/graphic-novel.webp",
    },
  ];

  const handlePrev = () => {
    onPrevSound?.();
    setType("");
    onPrev();
  };

  const handleNext = () => {
    if (!type) {
      onAlert(t("alerts.selectType"));
      return;
    }
    onNextSound?.();
    onNext();
  };

  return (
    <NikkiWrapper
      titleDescription={t("titleDescription")}
      progressValue="100"
      onNext={handleNext}
      onPrev={handlePrev}
      showPrev={true}
      onNextSound={onNextSound}
      onPrevSound={onPrevSound}
    >
      <h3>{t("title")}</h3>
      <div className="divider" />
      <ul className="genre-list">
        {genreList.map((genre) => (
          <li
            key={genre.value}
            className={type === genre.value ? "action" : ""}
            onClick={() => {
              onSelectSound?.();
              setType((prev) => (prev === genre.value ? "" : genre.value));
            }}
          >
            <figure>
              <img src={genre.img} alt={t(genre.labelKey)} />
            </figure>
            <p>{t(genre.labelKey)}</p>
          </li>
        ))}
      </ul>
    </NikkiWrapper>
  );
}
